
import { useState } from 'react';
import {
  RicercaSelezioneModal,
  EsternalizzazioneModal,
  ConsulenzaModal,
  FormazioneModal,
} from './ServiceModals';

type ModalType = 'ricerca' | 'esternalizzazione' | 'consulenza' | 'formazione' | null;

export default function Services() {
  const [activeModal, setActiveModal] = useState<ModalType>(null);

  const services = [
    {
      id: 'ricerca' as ModalType,
      icon: 'ri-search-line',
      tag: 'Talent Acquisition',
      title: 'Ricerca e Selezione',
      description: 'Identifichiamo e selezioniamo i professionisti più qualificati per ogni ruolo, attraverso un processo strutturato e su misura per la tua azienda.',
      highlights: ['Selezione executive e middle management', 'Screening e assessment avanzato', 'Garanzia di sostituzione'],
      hasForm: true,
    },
    {
      id: 'esternalizzazione' as ModalType,
      icon: 'ri-team-line',
      tag: 'Outsourcing HR',
      title: 'Esternalizzazione del Personale',
      description: 'Gestiamo integralmente il tuo personale esterno: contratti, buste paga, adempimenti contributivi e supporto operativo continuo.',
      highlights: ['Gestione contratti e payroll', 'Adempimenti fiscali e contributivi', 'Account dedicato H24'],
      hasForm: true,
    },
    {
      id: 'consulenza' as ModalType,
      icon: 'ri-line-chart-line',
      tag: 'Advisory & Finance',
      title: 'Consulenza Strategica',
      description: 'Consulenza finanziaria integrata per le aziende — recupero fiscale, ottimizzazione dei costi — e per i dipendenti — pianificazione finanziaria e coperture assicurative. Incluso nella fattura finale.',
      highlights: ['Recupero crediti fiscali aziendali', 'Ottimizzazione risorse per dipendenti', 'Coperture assicurative su misura'],
      hasForm: false,
    },
    {
      id: 'formazione' as ModalType,
      icon: 'ri-graduation-cap-line',
      tag: 'Training & Compliance',
      title: 'Formazione Professionale',
      description: 'Corsi obbligatori certificati D.Lgs 81/08, HACCP, Privacy GDPR e formazione specializzata per la ristorazione. In presenza, online o blended.',
      highlights: ['Sicurezza obbligatoria D.Lgs 81/08', 'HACCP e igiene alimentare', 'Formazione ristorazione & hospitality'],
      hasForm: false,
    },
  ];

  return (
    <>
      <section id="servizi" className="py-24" style={{background:'#F5F7FA'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-20">
            <div className="inline-block px-5 py-2 bg-white border border-gray-200 rounded-full text-xs font-semibold text-gray-700 tracking-wider mb-6">
              I NOSTRI SERVIZI
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              Soluzioni Complete<br />
              per le Tue Esigenze HR
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              Dalla ricerca del personale all&apos;outsourcing completo, offriamo servizi professionali su misura per ogni realtà aziendale
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {services.map((service) => (
              <div
                key={service.id}
                onClick={() => setActiveModal(service.id)}
                className="bg-white p-8 rounded-2xl hover:shadow-xl transition-all duration-300 hover:-translate-y-1 group cursor-pointer flex flex-col"
              >
                <div className="mb-5">
                  <span className="text-xs font-semibold tracking-wider uppercase" style={{color:'#B8860B'}}>{service.tag}</span>
                </div>
                <div className="w-12 h-12 flex items-center justify-center bg-gray-100 rounded-full mb-5 transition-colors duration-300 group-hover:bg-opacity-100" style={{}}>
                  <i className={`${service.icon} text-2xl text-gray-700 group-hover:text-white transition-colors duration-300`}
                    style={{}}
                  ></i>
                </div>
                <h3 className="text-lg font-bold text-gray-900 mb-3">{service.title}</h3>
                <p className="text-sm text-gray-600 leading-relaxed mb-5 flex-1">{service.description}</p>
                <ul className="space-y-1.5 mb-6">
                  {service.highlights.map((h, i) => (
                    <li key={i} className="flex items-start gap-2">
                      <i className="ri-check-line text-sm mt-0.5 flex-shrink-0" style={{color:'#B8860B'}}></i>
                      <span className="text-xs text-gray-500">{h}</span>
                    </li>
                  ))}
                </ul>
                <div className="flex items-center justify-between mt-auto">
                  <button className="text-sm font-semibold inline-flex items-center gap-2 group-hover:gap-3 transition-all whitespace-nowrap cursor-pointer" style={{color:'#1E3A5F'}}>
                    {service.hasForm ? 'Richiedi ora' : 'Scopri di più'}
                    <i className="ri-arrow-right-line"></i>
                  </button>
                  {!service.hasForm && (
                    <span className="text-xs px-2 py-0.5 rounded-full font-medium" style={{background:'#EEF2FF', color:'#1E3A5F'}}>Info</span>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {activeModal === 'ricerca' && <RicercaSelezioneModal onClose={() => setActiveModal(null)} />}
      {activeModal === 'esternalizzazione' && <EsternalizzazioneModal onClose={() => setActiveModal(null)} />}
      {activeModal === 'consulenza' && <ConsulenzaModal onClose={() => setActiveModal(null)} />}
      {activeModal === 'formazione' && <FormazioneModal onClose={() => setActiveModal(null)} />}
    </>
  );
}
